<!-- Empty layout -->
@if (layout === 'empty') {
<empty-layout></empty-layout>
}

<!-- Dense -->
@if (layout === 'dense') {
<dense-layout></dense-layout>
}
